import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import usePermissions from "../../../../../hooks/usePermissions";
import { FileUploadSection } from "../../../../../features/file-attachments/file-upload/components/file-upload-section/file-upload-section.component";

import * as workOrderStore from "../../../store/work-order.store";

import * as store from "../store/work-order-assets-tab.store";

export const WorkOrderAssetsTab = () => {
  const workOrder = useSelector(workOrderStore.getWorkOrder);
  const assets = useSelector(store.getAssets);
  const userPermissions = usePermissions();

  useEffect(() => {
    if (workOrder && !assets) {
      store.fetchAssets(workOrder.id);
    }
  }, [workOrder, assets]);

  return (
    <FileUploadSection
      assets={assets || []}
      canDelete={userPermissions.canEdit}
      isLoading={useSelector(store.isLoading)}
      onUpload={store.uploadFiles}
      onDelete={store.deleteAsset}
    />
  );
};
